import { useLocation } from 'react-router';

import type { Invoice } from '~/api/invoices/types';

import { useClientsWithTrashed } from '~/api/clients';
import { Icon, Link } from '~/components';
import { SearchParamKeys } from '~/constants/url';
import { r, routes } from '~/providers/RouterProvider/router.routes';
import { cellLinkStyle, desktopTruncateStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';
import { qs } from '~/utils/searchParams';

import { clientCellStyle } from './invoiceCell.css';

type Props = {
  invoice: Invoice;
};

export const InvoiceClientCell = ({ invoice }: Props) => {
  const { data: clients } = useClientsWithTrashed();
  const { pathname } = useLocation();

  const client = clients.find(({ id }) => id === invoice.clientId);

  if (!client) return '–';

  if (client.deleted) return <div className={desktopTruncateStyle}>{client.name}</div>;

  if (client.clientType === 'private' && !client.contacts[0]) {
    return <div className={desktopTruncateStyle}>{client.name}</div>;
  }

  const to =
    client.clientType === 'organisation'
      ? r(routes.showClient, { clientId: client.id })
      : r(routes.editContact, { clientId: client.id, contactId: client.contacts[0].id });

  const isSentWithPeppol =
    (invoice.status === 'Approved' && invoice.coTransportType === 'Peppol') ||
    (invoice.status === 'Credited' && invoice.creditNoteDetails?.coTransportType === 'Peppol');

  return (
    <div className={clsx(desktopTruncateStyle, clientCellStyle)}>
      {isSentWithPeppol && <Icon name="Peppol" />}

      <Link
        className={clsx(cellLinkStyle, desktopTruncateStyle)}
        to={{ pathname: to, search: qs({ [SearchParamKeys.REDIRECT_PATH]: pathname }) }}
      >
        {client.name}
      </Link>
    </div>
  );
};
